import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from './auth.guard';
import {LoginComponent} from './login/login.component';
import {LoginModule} from './login/login.module';
import {NoAuthGuard} from './no-auth.guard';
import {PreComponent} from './register/pre/pre.component';
import {PreModule} from './register/pre/pre.module';
import {RegisterComponent} from './register/register.component';
import {RegisterModule} from './register/register.module';
import {ResetComponent} from './reset/reset.component';
import {ResetModule} from './reset/reset.module';
import {VerifyComponent} from './verify/verify.component';
import {VerifyModule} from './verify/verify.module';
import {AuthTokenGuard} from './auth-token.guard';
import {UpdatePasswordComponent} from './update-password/update-password.component';
import {UpdatePasswordModule} from './update-password/update-password.module';
import {UserPasswordFormModule} from '../user-management/user-password/user-password-form/user-password-form.module';

const routes: Routes = [
  {path: 'authenticate', component: LoginComponent},
  {path: 'authenticate/logout', component: LoginComponent},
  {path: 'register/pre', component: PreComponent, canActivate: [NoAuthGuard]},
  {path: 'register', component: RegisterComponent, canActivate: [NoAuthGuard]},
  {path: 'reset', component: ResetComponent, canActivate: [NoAuthGuard]},
  {path: 'verify/:id', component: VerifyComponent, canActivate: [AuthGuard]},
  {path: 'update-password', component: UpdatePasswordComponent, canActivate: [AuthTokenGuard]},
];

@NgModule({
  imports: [
    LoginModule,
    PreModule,
    RegisterModule,
    ResetModule,
    VerifyModule,
    UpdatePasswordModule,
    RouterModule.forChild(routes),
  ],
  providers: [AuthTokenGuard],
})
export class AuthModule {}



// WEBPACK FOOTER //
// ./src/app/auth/auth.module.ts